import { getCampaignLiveStatus } from "../types/campaign-live-status.types";

export const getCampaignLiveStatusRequest = (payload) => ({
    type: getCampaignLiveStatus.GET_CAMPAIGN_LIVE_STATUS_REQUEST,
    payload,
});
export const getCampaignLiveStatusSuccess = (payload) => ({
    type: getCampaignLiveStatus.GET_CAMPAIGN_LIVE_STATUS_SUCCESS,
    payload,
});
export const getCampaignLiveStatusError = (payload) => ({
    type: getCampaignLiveStatus.GET_CAMPAIGN_LIVE_STATUS_ERROR,
    payload,
});